import Hero from './Hero';
import Solutions from './Solutions';
import Contact from './Contact';
import Staff from './Staff';

const Home = () => {
  return (
    <>
      <Hero />
      <Solutions />
      <Contact />
      <Staff />
    </>
  );
};

export default Home;
